import { useEffect, useState } from "react";
import { message, Card, Form, Select, Input, DatePicker, Row, Col, Button, Flex } from "antd";
import { dateFormat, menuLinks, notifyMessages, requiredMessages } from "../../utils/constants";
import { PageHeader } from "../../components/common/pageHeader";
import { Link, useParams, useNavigate } from "react-router";
import { SaveOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { useCurrentUserContext } from "../../context/currentUserContext.js";
import dayjs from 'dayjs';
import ContentLoader from "../../components/common/contentLoader";
import FgasDocumentsServices from "../../services/fgasDocumentServices.js";
import { handleDateConvertForApis } from "../../utils/functions.js";
import { fetchSuppliersList } from "../../state/slices/suppliersListSlice.js";


const FgasEditDocument = () => {
    const urlParams = useParams();
    const { currentUser } = useCurrentUserContext();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [fieldsChanged, setFieldsChanged] = useState(false);
    const [loadingButton, setLoadingButton] = useState(false);
    const [documentData, setDocumentData] = useState(null);
    const suppliersList = useSelector(state => state.suppliers.suppliers);
    const anomaliesList = useSelector(state => state.anomalies.anomalies);
    const intervetionTypesList = useSelector(state => state.intervetionTypes.intervetionTypes);

    useEffect(() => {
        getDocumentData(urlParams.id, currentUser.id);
    }, []);

    useEffect(() => {
        if (!currentUser) return;
        dispatch(fetchSuppliersList(currentUser.lastSelectedCategory, false, currentUser.id));
    }, [dispatch, currentUser]);

    const getDocumentData = async (documentId, userId) => {
        try {
            const respData = await FgasDocumentsServices.getFgasDocumentDetails(documentId, userId);
            if (respData.success) {
                setDocumentData(respData.responseObject.value.documentDetails_FGAS_DTO);
            } else {
                message.error(notifyMessages.errorAccured);
            }
        } catch (error) {
            message.error(notifyMessages.errorAccured);
        }
    };

    const onSupplierChange = (option) => {
        //  const selectedOption = suppliersList.filter(supplier => supplier.value === option);         
        // form.setFieldsValue({ Code: selectedOption[0].vatCode || "" });
    }

    const updateData = async (values) => {

        values["id"] = documentData.id;
        values["lastEditedUser"] = currentUser.id;
        values.dateAdded = handleDateConvertForApis(values.dateAdded);

        console.log("values", values)
        setLoadingButton(true);
        try {
            const respData = await FgasDocumentsServices.updateDocument(values);
            if (respData.success) {
                message.success(notifyMessages.operationSuccess);
                navigate(`${menuLinks.fgas}/view/id/${urlParams.id}`);
            } else {
                message.error(respData.ErrorDetail?.ErrorMessage || notifyMessages.errorAccured);
            }
        } catch (error) {
            message.error(notifyMessages.errorAccured);
        } finally {
            setLoadingButton(false);
        }
    };


    return (
        <div className="edit-document">

            <PageHeader title={"Modifica documento"} />

            {!documentData && <ContentLoader />}

            {documentData && (
                <>
                    <Card title="Dati documento" size="small" className="editCard">
                        <Form
                            id="editDocument"
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 8 }}
                            onFinish={updateData}
                            onValuesChange={() => setFieldsChanged(true)}
                        >

                            <Form.Item
                                label="Codice"
                                name="code"
                                initialValue={documentData.code}
                            >
                                <Input />
                            </Form.Item>

                            <Form.Item
                                label="Data caricamento"
                                name="dateAdded"
                                rules={[{ required: true, message: requiredMessages.requiredField }]}
                                initialValue={documentData.dateAdded ? dayjs(documentData.dateAdded) : null}
                            >
                                <DatePicker format={dateFormat} />
                            </Form.Item>

                            <Form.Item
                                label="Anomalia"
                                name="anomalyId"
                                // rules={[{ required: true, message: requiredMessages.requiredField }]}
                                initialValue={documentData.anomalyId}
                            >
                                <Select
                                    allowClear
                                    showSearch
                                    optionFilterProp="label"
                                    options={anomaliesList}
                                />
                            </Form.Item>

                            <Form.Item
                                label="Manutentore"
                                name="supplierId"
                                rules={[{ required: true, message: requiredMessages.requiredField }]}
                                initialValue={documentData.supplierId}
                            >
                                <Select
                                    options={suppliersList}
                                    allowClear
                                    showSearch
                                    optionFilterProp="label"
                                    onChange={(option) => onSupplierChange(option)}
                                />
                            </Form.Item>

                            <Form.Item
                                label="Operatore"
                                name="operatore"
                                initialValue={documentData.operatore}
                                rules={[{ required: true, message: requiredMessages.requiredField }]}
                            >
                                <Input />
                            </Form.Item>

                            <Form.Item
                                label="PIVA / CF Operatore"
                                name="pivA_Operatore"
                                initialValue={documentData.pivA_Operatore}
                                rules={[{ required: true, message: requiredMessages.requiredField }]}
                            >
                                <Input />
                            </Form.Item>

                            <Form.Item
                                label="Intervento"
                                name="interventionTypeId"
                                rules={[{ required: true, message: requiredMessages.requiredField }]}
                                initialValue={documentData.interventionTypeId}
                            >
                                <Select
                                    allowClear
                                    showSearch
                                    optionFilterProp="label"
                                    options={intervetionTypesList}
                                />
                            </Form.Item>

                            <Form.Item
                                label="Batch"
                                name="Flux"
                                initialValue={documentData.flux}
                            >
                                <Input />
                            </Form.Item> 

                            <Form.Item
                                label="Note"
                                name="Notes"
                                initialValue={documentData.notes}
                            >

                                <Input.TextArea rows={3} />
                            </Form.Item>
                        </Form>
                    </Card>

                    <Row gutter={24} >
                        <Col span={24} className="modifyDocButtons">
                            <Flex gap="small" wrap>
                                <Button type="default">
                                    <Link to={`${menuLinks.fgas}/view/id/${urlParams.id}`}>Annulla</Link>
                                </Button>

                                <Button
                                    loading={loadingButton}
                                    type="primary"
                                    htmlType="submit"
                                    disabled={!fieldsChanged}
                                    form="editDocument"
                                >
                                    <SaveOutlined /> Salva
                                </Button>
                            </Flex>
                        </Col>
                    </Row>
                </>
            )}
        </div>
    );
};

export default FgasEditDocument;
